export default (metric, { colour = '#ff0000' } = {}) => {
    const defaultText = metric.pdfDescription;
    // const label = metric.label;
    const template = {
        colour,
        // border: { colour },
        label: {
            // h: label.length > 47 ? 'h-0-1/2' : 'h-0-3/8',
            // border: { colour: '#0000ff' },
            text: `${metric.pdfLabel}`,
            font: { weight: 'bold', colour: '#444444' },
            superscript: `${metric.reference.index}`,
            pageNumber: 3,
            // mb: 'h-0-1/16'
        },
        chart: {
            font: { lineHeight: 1.05 },
            h: 'h-1-1/4',
            y: 'h-0-1/16',
            w: 'w-4'
        },
        definition: {
            mt: 6,
            text: defaultText
        }
    };
    return template;
};
